
import * as clock from "./clock.js";
import * as utc from "./utc.js";

/** @returns {object} date parts for now according to the default clock */
export function now() {
    return utc.parts(clock.now());
}

/**
 * @param {string} time_cursor ISO string or "now" special keyword
 * @returns {object} date parts, with "now" resolved to the default clock's current time
 */
export function resolveTimeCursor(time_cursor) {
    return time_cursor === "now" ? now() : utc.parts(time_cursor);
}
